export const REFRESH_STAFF = 'messages/REFRESH_STAFF'
export const REFRESH_STORES = 'messages/REFRESH_STORES'
export const REFRESH_INSURANCES = 'messages/REFRESH_INSURANCES'
export const REFRESH_BRANDS = 'messages/REFRESH_BRANDS'
export const REFRESH_SALES_ASSISTANT = 'messages/REFRESH_SALES_ASSISTANT'
export const REFRESH_MECHANIC = 'messages/REFRESH_MECHANIC'
export const REFRESH_SHOP_CATEGORIES = 'messages/REFRESH_SHOP_CATEGORIES'
export const CLEAR__STORES = 'messages/CLEAR__STORES'
export const MESSAGE_OLIST = 'messages/MESSAGE_OLIST'
export const MESSAGE_COUNT = 'messages/MESSAGE_COUNT'
export const WX_STATUS = 'messages/WX_STATUS'
export const JUDGE_AUDIO = 'messages/JUDGE_AUDIO'
export const MINI_STATUS = 'messages/MINI_STATUS'



// WEBPACK FOOTER //
// ./src/vuex/modules/profiles/types.js